module.exports = __webpack_public_path__ + "img/hospital_4.e23fa0b5.png";